export default {
  placeholder: 'Vybrať diel',
};
